import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
import { FAQS } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-carbon" aria-labelledby="faq-heading" data-id="element-95">
      <SectionReveal className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-96">
        <h2 id="faq-heading" className="mb-10 text-center font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-97">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-98">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="overflow-hidden rounded-lg border-b border-gold-tenue" data-id="element-99">
                <h3 data-id="element-100">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 bg-carbon-3 px-5 py-4 text-left font-heading font-bold text-soft transition-colors hover:bg-carbon-3/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange" data-id="element-101">
                    {faq.question}
                    {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-orange" data-id="element-102" /> : <PlusIcon className="h-5 w-5 flex-none text-orange" data-id="element-103" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-104">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-carbon-2" data-id="element-105">
                      <p className="px-5 py-4 text-muted" data-id="element-106">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </SectionReveal>
    </section>;
}